const local = {
  get(key) {
    const rawValue = localStorage.getItem(key);
    if (rawValue === null) {
      return null;
    }
    try {
      return JSON.parse(rawValue);
    } catch (e) {
      return rawValue;
    }
  },

  put: ({ key, value }) => localStorage.setItem(key, JSON.stringify(value)),
  remove: (key) => localStorage.removeItem(key),
};

export default local;
